/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { RunProgramExtra } from './RunProgramExtra';
const RunProgramInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(RunProgramExtra, AutoTestStepBaseInputAsJSON);
export class RunProgramInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return RunProgramInputAsJSONParser.decode(input).map(res => new RunProgramInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return RunProgramInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RunProgramInputAsJSONParser.encode(data);
    }
    static schema() {
        return RunProgramInputAsJSONParser.schema();
    }
}
